"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utilities = require("../../utilities");
var _radioButtonModule = _interopRequireDefault(require("./radioButton.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RadioButton = function RadioButton(props) {
  var style = {};
  if (props.disabled) {
    style.cursor = "not-allowed";
  }
  return /*#__PURE__*/_react["default"].createElement("label", _extends({
    className: _radioButtonModule["default"].radioButton,
    "data-testid": "radio-label"
  }, _utilities.utilities.getDataAttributes(props), {
    style: _objectSpread(_objectSpread({}, props.style), style)
  }), /*#__PURE__*/_react["default"].createElement("input", {
    type: "radio",
    "data-testid": "radio-radio",
    name: props.name,
    checked: props.checked,
    disabled: props.disabled && "disabled",
    onChange: function onChange(e) {
      if (!props.disabled && props.onChange) {
        props.onChange(e);
      }
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: _radioButtonModule["default"].checkMark,
    "data-testid": "radio-box"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _radioButtonModule["default"].radio
  })), props.label);
};
RadioButton.propTypes = {
  label: _propTypes["default"].string,
  name: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  onChange: _propTypes["default"].func
};
RadioButton.defaultProps = {
  label: "Label",
  name: "radio"
};
var _default = exports["default"] = RadioButton;